<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-body">
        <h5 class="text-center">REPORTE DE EMPRESAS</h5>

        <div class="row">
          <div class="col-lg-3">
            <div class="form-group">
              <label class="mr-1">Empresas:</label>
              <select class="form form-control" 
                v-model="id_empresa"
                @change="vaciar($event)">
                <option value="">SELECCIONAR</option>
                <option v-for="(item,index) in empresas"
                 :value="item.id_empresa" :key="index">
                 {{ item.emp_razon_social }}
                 </option>
              </select>
            </div>
          </div>

          <div class="col-lg-3 mt-2"><br>
            <a
              class="btn btn-info mr-1"
              title="Buscar"
              @click="listarDatos(id_empresa)"
            >
              <i class="fa fa-search"></i> Buscar
            </a>
          </div>
          <div class="col-lg-3 mt-2"><br>
            <a
              class="btn btn-success mr-1"
              title="Imprimir"
              @click="exportarXls"
            >
              <i class="fa fa-print"></i> Imprimir
            </a>
          </div>
        </div>

        <div
          class="table-responsive mt-3"
          style="overflow-y:scroll; height:380px;"
        >
          <table class="table table-bordered">
            <tr class="text-center">
              <th><small class="font-weight-bold">#</small></th>
              <th><small class="font-weight-bold">FECHA INICIO</small></th>
              <th><small class="font-weight-bold">FECHA FIN</small></th>
              <th><small class="font-weight-bold">TOTAL</small></th>
              
            </tr>
            <tr v-for="(item, index) in registros" :key="index" class="text-center">
              <td>
                <small>{{ index + 1 }}</small>
              </td>
              <td>
                <small>{{ item.fecha_inicio }}</small>
              </td>
              <td>
                <small>{{ item.fecha_fin }}</small>
              </td>
              <td>
                <small>{{ item.total }}</small>
              </td>

            
            </tr>
          </table>
        </div>
      </div>
    </div>
    <Loading v-show="cargando" />
  </div>
</template>

<script>
import Loading from "../../components/Loading";
import moment from "moment";

export default {
  name:'reportePorEmpresas',
  components: {
    Loading,
  },
  data() {
    return {
      registros: [],
      resultados: [],
      empresas: [],
      id_empresa: 0,
      submitted: false,
      cargando: false
    };
  },
  methods: {
    
    async listarDatos(id_empresa) {
      //console.log(id_empresa);
      try {
        this.resultados = await this.axios.get(`/empresa/reportePartes/${id_empresa}`);

        this.registros = this.resultados.data.contenido;

      } catch (error) {
        console.log('catch: ',error);
      }
    },
    async listarEmpresa() {
      try {
        this.resultados = await this.axios.get(`/listaEmpresaReporte`);
        this.empresas = this.resultados.data.contenido;
        
      } catch (error) {
        console.log(error);
      }
    },
   
    getDate: function(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    formatFecha(event) {
      let str = event;
      let arrayFecha = str.split("-");
      return arrayFecha[2] + "/" + arrayFecha[1] + "/" + arrayFecha[0];
    },
    crearDescarga(response, title) {
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'blob' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', title);
      document.body.appendChild(link);
      link.click();
    },
    async exportarXls(){
      let config = { headers: { token: this.token }, responseType: 'blob' };
      this.cargando = true;
      try {
        //console.log('2: ',this.id_empresa);
        this.resultados = await this.axios.get(`/reporteEmpresa_xls/${this.id_empresa}`, config);
        //console.log('1:', this.resultados);
        await this.crearDescarga(this.resultados, 'reporte.xlsx');
       // this.registros = this.resultados.data.contenido;
        this.cargando = false;
      } catch (error) {
        console.log(error);
        this.cargando = false;
      } 
    },
    vaciar(event){
      //this.registros = [];
      // Obtiene id_empresa
      this.id_empresa = event.target.options[event.target.selectedIndex].value;
      //console.log('id: ',this.id_empresa);
    }
  },
  created() {
    this.listarEmpresa();
   
  },

};
</script>
